import { Badge } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { OrderStatus } from '../../gql/graphql';
import { orderStatusLabelMapper } from '../../hooks/order';

interface OrderBadgeProps {
  orderStatus: OrderStatus;
}

function orderStatusColorSchemeMapper(orderStatus: OrderStatus): string {
  switch (orderStatus) {
    case OrderStatus.Open:
      return 'orange';
    case OrderStatus.InProgress:
      return 'cyan';
    case OrderStatus.Completed:
      return 'green';
    default:
      return 'gray';
  }
}

export default function OrderBadge({
  orderStatus,
}: OrderBadgeProps): React.ReactElement {
  const { t } = useTranslation('project');
  return (
    <Badge
      size={'md'}
      px={2}
      colorScheme={orderStatusColorSchemeMapper(orderStatus)}
    >
      {orderStatusLabelMapper(orderStatus, t)}
    </Badge>
  );
}
